
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/drill",
      function () {
        return require("private-next-pages/campaigns/drill/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/drill"])
      });
    }
  